export default "__VITE_ASSET__ba0b0883__"